module.exports = __webpack_public_path__ + "img/LogoDashboard-18.5ef48dea.svg";